import { useState, useEffect, useRef } from "react";

const Banner = () => {
  // Animation control for financial icons
  const [visible, setVisible] = useState(false);
  const hasSetVisible = useRef(false);

  useEffect(() => {
    if (!hasSetVisible.current) {
      hasSetVisible.current = true;
      // Use a small delay to prevent immediate re-render cascade
      const timer = setTimeout(() => {
        setVisible(true);
      }, 50);

      return () => clearTimeout(timer);
    }
  }, []);

  return (
    <section className="relative py-16 md:py-24 bg-orange-100/10">
      {/* Naira symbol - more bold and visible */}
      <div
        className={`absolute right-8 md:right-16 top-10 md:top-16 text-green-600 text-6xl md:text-8xl font-bold transform transition-all duration-1000 ${
          visible ? "opacity-30 scale-100" : "opacity-0 scale-50"
        }`}
      >
        ₦
      </div>

      {/* Trending up arrow */}
      <div
        className={`absolute left-8 md:left-16 top-20 md:top-32 transition-all duration-700 delay-300 ${
          visible ? "opacity-50 translate-x-0" : "opacity-0 -translate-x-12"
        }`}
      >
        <svg
          className="w-12 h-12 md:w-20 md:h-20 text-green-500"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"
          />
        </svg>
      </div>

      {/* Trending down arrow */}
      <div
        className={`absolute right-12 md:right-24 bottom-16 md:bottom-24 transition-all duration-700 delay-500 ${
          visible ? "opacity-50 translate-y-0" : "opacity-0 translate-y-12"
        }`}
      >
        <svg
          className="w-10 h-10 md:w-16 md:h-16 text-red-500"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M13 17h8m0 0V9m0 8l-8-8-4 4-6-6"
          />
        </svg>
      </div>

      {/* Central content */}
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <h1
            className={`text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight transform transition-all duration-1000 ease-out ${
              visible
                ? "opacity-100 translate-x-0"
                : "opacity-0 -translate-x-20"
            }`}
          >
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-red-600 to-red-800">
              Enabling Inclusive Payments Across Africa
            </span>
          </h1>

          <p
            className={`text-lg sm:text-xl md:text-2xl text-gray-700 mb-8 max-w-3xl mx-auto transform transition-all duration-1000 ease-out delay-300 ${
              visible
                ? "opacity-100 translate-x-0"
                : "opacity-0 -translate-x-16"
            }`}
          >
            VasPay helps African businesses get paid from anywhere in the world
            with speed, simplicity, and dependable service.
          </p>

          <div
            className={`flex flex-col sm:flex-row justify-center gap-4 transform transition-all duration-1000 ease-out delay-600 ${
              visible
                ? "opacity-100 translate-x-0"
                : "opacity-0 -translate-x-12"
            }`}
          >
            <button className="inline-flex items-center justify-center px-6 py-3 bg-red-500 hover:bg-red-600 text-white font-medium rounded-md transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1 text-lg">
              Get Started
              <svg
                className="ml-2 h-5 w-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M13 7l5 5-5 5M6 7l5 5-5 5"
                />
              </svg>
            </button>

            <button className="inline-flex items-center justify-center px-6 py-3 bg-white text-red-600 border-2 border-red-500 font-medium rounded-md transition-all duration-300 shadow-md hover:shadow-lg transform hover:-translate-y-1 hover:bg-red-50 text-lg">
              Learn More
              <svg
                className="ml-2 h-5 w-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Banner;
